import { render } from "./JoinPage.vue?vue&type=template&id=99a9a7e2&scoped=true"
import script from "./JoinPage.vue?vue&type=script&lang=js"
export * from "./JoinPage.vue?vue&type=script&lang=js"

import "./JoinPage.vue?vue&type=style&index=0&id=99a9a7e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99a9a7e2"]])

export default __exports__